import React, { useEffect, useState } from 'react'
import classes from "./OtpPage.module.css";
import Layout from '../component/Layout';
import SubLayout from '../component/SubLayout';
import Header from '../component/Header';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import OTPInput from 'react-otp-input';
import { toast } from 'react-toastify';
import SmallLoader from '../component/SmallLoader';
import { FaArrowLeft } from "react-icons/fa6";
import { useTranslation } from 'react-i18next';
import { subApi } from "../http/http";
import { setUserDetails } from "../store/slices/userSlice";

const OtpPage = () => {

    const [otp, setOtp] = useState("");
    const [timer, setTimer] = useState(300);
    const navigate = useNavigate();
    const [msisdn, setMsisdn] = useState("");
    const [alias, setAlias] = useState('');
    const [otpId, setOtpId] = useState("");
    const [resend, setResend] = useState(false);
    const [resendLoading, setResendLoading] = useState(false);
    const [loading, setLoading] = useState(false);   
    const location = useLocation();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    

    useEffect(() => {
        if (location.state?.msisdn) {
            setMsisdn(location.state?.msisdn);
            setOtpId(location.state?.otpId);
        }
        else { navigate("/");}
    }, [location])


    const handleFormSubmission =  () => {
        try {
            if (otp.length <= 3) {return;}
            setLoading(true);
            subApi({"action":4,"serviceId":1,"ani":msisdn,"otp":otp,"otpId":otpId}).then((res) => {
                //console.log(res)
                if(res?.data?.responseCode === 202)
                {
                    setLoading(false);
                    dispatch(setUserDetails(res?.data?.data));
                    window.location.href ="/home";
                }
                else
                {
                    setAlias(res?.data?.data);
                    setLoading(false);
                    navigate("/select-subscription", {state: {alias:res?.data?.data} })                   
                }
            }).catch((err) => {
                console.log(err);
                setLoading(false);
                 toast.error(err?.response?.data?.message || err?.response?.message || err?.data?.message || "Something Went Wrong!");
            });
           
        } catch (error) {
            setLoading(false);
            toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || "Something Went Wrong!");
        }
    }

    const resendOtpHandler = async () => {

        try {
            setResendLoading(true);
            //const response = await subApi({"action":3,"serviceId":1,"ani":msisdn});
            setTimer(300);
            setResendLoading(false);
            //setOtpId(response?.data?.data);
            setResend(true);
            setOtp("");
            toast.success("Otp has been resent successfully!");
        } catch (error) {
            setResendLoading(false);
            toast.error(error?.response?.message);
        }
    }

    useEffect(() => {
        const countdown = setInterval(() => {
            setTimer((prevTimer) => prevTimer - 1);
        }, 1000);

        return () => {
            clearInterval(countdown);
        };
    }, []);

    useEffect(() => {
        if (timer <= 0) {
            navigate("/");
        }
    }, [timer]);

    return (
        <Layout>
            <SubLayout>
                <Header hide={true} />

                <div className={classes.container}>

                    <div className={classes.otp_description}>
                        <h2 className={classes.title}>{t("8")}</h2>
                        <p className={classes.text}>
                            {t("9")} {resend && t("10")} {t("11")}
                            <span className={classes.bold}> +237 {msisdn} </span>
                            {t("12")}
                        </p>
                    </div>


                    <div className={classes.otp_input_container}>
                        <OTPInput
                            value={otp}
                            shouldAutoFocus
                            onChange={setOtp}
                            numInputs={4}
                            renderSeparator={<span className={classes.gap}></span>}
                            renderInput={(props) => (
                                <input {...props} type="number" className={classes.input_box} />
                            )}
                        />
                    </div>

                    <div className={classes.time_container}>
                        <p className={classes.time_text}>{t("13")} {timer} {t("14")}</p>
                    </div>

                    {(loading || resendLoading) ? <div style={{ width: "100%", display: "grid", placeContent: "center" }}>
                        <SmallLoader />
                    </div> : (
                        <div className={classes.btn_container}>
                            <button
                                type="button"
                                className={classes.confirm_btn}
                                disabled={loading}
                                onClick={handleFormSubmission}
                            >
                                {t("15")}
                            </button>                           
                            <button type="button" className={classes.back_button} onClick={() => navigate("/")}>
                                <FaArrowLeft className={classes.back_icon} /> {t("16")}
                            </button>
                        </div>
                    )}
                </div>

            </SubLayout>
        </Layout>
    )
}

export default OtpPage